import { render, staticRenderFns } from "./ProjectsHistory.vue?vue&type=template&id=52638e5b&scoped=true&"
import script from "./ProjectsHistory.vue?vue&type=script&lang=js&"
export * from "./ProjectsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsHistory.vue?vue&type=style&index=0&id=52638e5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52638e5b",
  null
  
)

export default component.exports